import { Button, type ButtonProps, Group, Tooltip } from '@mantine/core'
import { IconBookmark, IconBookmarkFilled, IconEyeFilled, IconEyeOff } from '@tabler/icons-react'
import type { Movie } from '../../api_types.ts'

interface ActionsProps {
  movie: Movie
  size?: ButtonProps['size']
  fullWidth?: boolean
  isSaving?: boolean
  isHiding?: boolean
  onSave(): void
  onHide(): void
}

export function MovieActions({ movie, size, fullWidth, isHiding, isSaving, onSave, onHide }: ActionsProps) {
  return (
    <Group gap="0">
      <Tooltip label={movie.saved ? 'Unsave movie' : 'Save movie'} openDelay={500}>
        <Button
          size={size || 'sm'}
          variant="subtle"
          c="dark.2"
          style={{ flexGrow: fullWidth ? 1 : undefined }}
          loading={isSaving}
          onClick={e => {
            e.preventDefault()
            onSave()
          }}
        >
          {movie.saved ? <IconBookmarkFilled/> : <IconBookmark/>}
        </Button>
      </Tooltip>

      <Tooltip label={movie.hidden ? 'Unhide movie' : 'Hide movie'} openDelay={500}>
        <Button
          size={size || 'sm'}
          variant="subtle"
          c="dark.2"
          style={{ flexGrow: fullWidth ? 1 : undefined }}
          loading={isHiding}
          onClick={e => {
            e.preventDefault()
            onHide()
          }}
        >
          {movie.hidden ? <IconEyeOff/> : <IconEyeFilled/>}
        </Button>
      </Tooltip>
    </Group>
  )
}
